import TabAlteracoesService from "./TabAlteracoesService";

export default {
  mixins: [TabAlteracoesService],
  props: {
    idRnpPrestador: {
      type: [String, Number],
      default: -1
    }
  },
  data() {
    return {
      listaArquivos: [],
      loading: false
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.inicializarListagemJustificativas().finally(() => {
        this.sleep(150).then(() => {
          this.loading = false;
        });
      });
    },
    inicializarListagemJustificativas() {
      return new Promise((resolve, reject) => {
        this.getArquivosJustificativa(this.idRnpPrestador)
          .then(res => {
            this.montarArquivos(res.data);
            if (res.data.length === 0) {
              this.$emit("lista-arquivos-vazio", this.mostrarSingular);
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    montarArquivos(arquivos) {
      this.listaArquivos = [];

      arquivos.forEach(e => {
        const {
          // usuarioAlteracao,
          // usuarioUpload,
          uuid,
          id,
          arquivo: nomeArquivo,
          baixavel,
          dtAlteracao: dataAlteracao,
          dtUpload: dataEnvio,
          status: { chave: statusChave, descricao: mensagemStatus }
        } = e;
        const objetoArquivo = {
          tipoArquivo: statusChave,
          objetoArquivo: {
            nomeArquivo,
            tamanhoArquivo: "",
            dataEnvio: dataEnvio
              ? this.$helpers.formatadorHorario(dataEnvio)
              : "",
            dataAlteracao: dataAlteracao
              ? this.$helpers.formatadorHorario(dataAlteracao)
              : "",
            barraProgresso: 0,
            baixavel,
            mensagemStatus,
            id,
            uuid,
            mostrarIconeExcluir: this.mostrarSingular
          }
        };
        this.listaArquivos.push(objetoArquivo);
      });
    },
    /**
     *
     * @param {{
     *   formData: FormData,
     *   objetoArquivoUpload: {
     *     tipoArquivo: String,
     *     objetoArquivo: {
     *       nomeArquivo: String,
     *       tamanhoArquivo: String,
     *       barraProgresso: Number
     *     }
     *   }
     * }} objetoUpload
     */
    uploadArquivo(objetoUpload) {
      const { formData, objetoArquivoUpload } = objetoUpload;

      this.listaArquivos.unshift(objetoUpload.objetoArquivoUpload);

      this.sleep(500).then(() => {
        this.putUploadArquivo(formData, this.idRnpPrestador, porcentagem => {
          objetoArquivoUpload.objetoArquivo.barraProgresso = porcentagem;
        })
          .then(() => {
            this.sleep(150).then(() => {
              this.init();
              this.$emit("iniciar-prestador");
            });
          })
          .catch(err => {
            if (err.cancelado) {
              this.sleep(200).then(() => {
                this.init();
              });
              return;
            }

            objetoArquivoUpload.objetoArquivo.barraProgresso = 0;
            this.$store.commit("setCallbackFecharErro", () => {
              this.listaArquivos.shift();
            });
          });
      });
    },

    baixarArquivo(uuid) {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadArquivo(uuid)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },

    /// FLUXO ANALISTA

    aprovarArquivo(ObjetoAcao) {
      const { id, uuid } = ObjetoAcao;

      this.$store.commit("setLoadingModal", true);

      this.putAprovarJustificativa(id, uuid)
        .then(() => {
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.init();
          });
          this.$store.commit(
            "setSubtituloSucesso",
            "Arquivo aprovado com sucesso!"
          );
          this.$store.commit("setMostrarSucessoModal", true);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    reprovarArquivo(ObjetoAcao) {
      const { id, uuid } = ObjetoAcao;

      this.$store.commit("setLoadingModal", true);

      this.putReprovarJustificativa(id, uuid)
        .then(() => {
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.init();
          });
          this.$store.commit(
            "setSubtituloSucesso",
            "Arquivo reprovado com sucesso!"
          );
          this.$store.commit("setMostrarSucessoModal", true);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  }
};
